<template>
    <div>
        <q-inner-loading :showing="loading" label="Please wait, retrieving past responses " label-class="text-teal"
            label-style="font-size: 1.1em" />
        <div v-show="myStep >= 1">
            <h4>
                <i :style="{ cursor: 'pointer' }">
                    <q-icon name="chevron_left" v-if="myStep >= 1" @click="$emit('exit')" />
                </i>
                Te Iti Kahurangi
            </h4>

            <h6 class="form-subtitle">
                {{ selectedClient?.first_name }} {{ selectedClient?.last_name }}
                <q-btn size="16px" icon="o_history" no-caps flat outlined class="text-body2" color="grey-7"
                    @click="showHistoricResponses = true">&nbsp; View Past Responses</q-btn>
            </h6>

            <div v-show="myStep != 7" class="row">
                <div class="col-12 col-md-9">
                    <q-banner class="bg-grey-2 text-grey-9 banner-top-radius">
                        <div class="text-center text-weight-medium text-h6">
                            Select a star to score the following questions 1 - 5.
                        </div>
                    </q-banner>
                    <q-banner class="bg-grey-1 text-grey-9 banner-bottom-radius">
                        <div class="text-center text-caption">
                            1 - Needs a lot of work • 2 - Needs some work • 3 - Okay • 4 - Happy • 5 - Awesome
                        </div>
                    </q-banner>
                </div>
            </div>
        </div>

        <q-dialog v-model="showHistoricResponses" @close="showHistoricResponses = false">
            <FormHistoryResponse :clientId="selectedClient?.client_id" formType="Te Iti Kahurangi" />
        </q-dialog>

        <!-- Step 1 -->
        <div class="input-form-parent-container">
            <div class="q-my-md">
                <q-btn-dropdown :label="currentSectionTitle" color="primary" flat no-caps icon="menu"
                    class="q-ma-md text-body2">
                    <q-list>
                        <q-item v-for="section in sections" :key="section.step" clickable v-close-popup
                            @click="setStep(section.step)" :class="{ 'bg-grey-3': myStep === section.step }">
                            <q-item-section>
                                <q-item-label>{{ section.title }}</q-item-label>
                            </q-item-section>
                            <q-item-section side v-if="myStep === section.step">
                                <q-icon name="check" color="primary" />
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
                <q-separator />
            </div>
            <div v-show="myStep == 1">
                <div class="input-form-question-title hidden">
                    <h5>Ūkaipō (Relationships)</h5>
                </div>

                <div class="input-form-question-container">
                    <div class="input-form-item">
                        <span class="input-question-text">How are things with Whānau?</span>
                            <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion5" @update:rating="ratingQuestion5 = $event" />
                        <q-input v-model="question9Whanau" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text">How are things with Friends?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion6" @update:rating="ratingQuestion6 = $event" />
                        <q-input v-model="question9Friends" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text">How are things with your community</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion7" @update:rating="ratingQuestion7 = $event" />
                        <q-input v-model="question9Community" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text">How are things with your Iwi and/or Hāpū</span>
                            <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion8" @update:rating="ratingQuestion8 = $event" />
                        <q-input v-model="question9Iwi" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />

                    <div class="input-form-item">
                        <span class="input-question-text">Please provide a goal to help you achieve the changes you want to
                            make
                        </span>
                    </div>
                    <div class="input-form-item">
                        <q-input class="full-width" outlined v-model="question10" type="textarea" spellcheck="true"
                            label="Enter your answer" />
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div v-show="myStep == 2">
                <div class="input-form-question-title hidden">
                    <h5>Hinengaro (Mind)</h5>
                </div>

                <div class="input-form-question-container">
                    <div class="input-form-item">
                        <span class="input-question-text"> How confident are you in setting goals for yourself?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion11" @update:rating="ratingQuestion11 = $event" />
                        <q-input v-model="question17GoalSetting" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How well are you managing your mood?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion12" @update:rating="ratingQuestion12 = $event" />
                        <q-input v-model="question17MoodManagement" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How well are you managing habits or addictions?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion13" @update:rating="ratingQuestion13 = $event" />
                        <q-input v-model="question17Habits" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How well are you managing unwelcome thoughts or feelings?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion14" @update:rating="ratingQuestion14 = $event" />
                        <q-input v-model="question17ManagingUnwelcomeThoughts" dense spellcheck="true" type="text"
                            maxlength="255" placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How comfortable are you asking for help when needed?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion15" @update:rating="ratingQuestion15 = $event" />
                        <q-input v-model="question17AskingForHelp" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How would you rate your problem-solving skills?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion16" @update:rating="ratingQuestion16 = $event" />
                        <q-input v-model="question17ProblemSolving" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />

                    <div class="input-form-item">
                        <span class="input-question-text">Please provide a goal to help you achieve the changes you want to
                            make
                            if you have any: </span>
                    </div>
                    <div class="input-form-item">
                        <q-input class="full-width" outlined v-model="question18" type="textarea" spellcheck="true"
                            label="Enter your answer" />
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div v-show="myStep == 3">
                <div class="input-form-question-title hidden">
                    <h5>Tinana (Physical)</h5>
                </div>

                <div class="input-form-question-container">
                    <div class="input-form-item">
                        <span class="input-question-text"> How comfortably are you able to move without pain or
                            distress?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion19" @update:rating="ratingQuestion19 = $event" />
                        <q-input v-model="question25MovingWithoutPain" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How would you rate your exercise habits and physical
                            health?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion20" @update:rating="ratingQuestion20 = $event" />
                        <q-input v-model="question25Exercise" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How would you rate your eating habits?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion21" @update:rating="ratingQuestion21 = $event" />
                        <q-input v-model="question25HealthyEating" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How would you rate your habits around visiting a doctor, dentist,
                            or
                            chemist when needed?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion22" @update:rating="ratingQuestion22 = $event" />
                        <q-input v-model="question25VisitingHealthProfessionals" dense spellcheck="true" type="text"
                            maxlength="255" placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How well are you managing your use of alcohol, tobacco, or other
                            substances?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion23" @update:rating="ratingQuestion23 = $event" />
                        <q-input v-model="question25ManagingAlcohol" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Using traditional Māori medicine (Rongoa/Mirimiri)?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion24" @update:rating="ratingQuestion24 = $event" />
                        <q-input v-model="question25UsingTraditionalMaoriMedicine" dense spellcheck="true" type="text"
                            maxlength="255" placeholder="Comments" />
                    </div>
                    <q-separator />

                    <div class="input-form-item">
                        <span class="input-question-text">Please provide a goal to help you achieve the changes you want to
                            make
                            if you have any: </span>
                    </div>
                    <div class="input-form-item">
                        <q-input class="full-width" outlined v-model="question26" type="textarea" spellcheck="true"
                            label="Enter your answer" />
                    </div>
                </div>
            </div>

            <!-- Step 4 -->
            <div v-show="myStep == 4">
                <div class="input-form-question-title hidden">
                    <h5>Taiao (Environment)</h5>
                </div>

                <div class="input-form-question-container">
                    <div class="input-form-item">
                        <span class="input-question-text">
                            How would you rate your current housing situation (warmth, dryness, space, power, phone)?
                        </span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion27" @update:rating="ratingQuestion27 = $event" />
                        <q-input v-model="question32Housing" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How accessible is transport for you?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion28" @update:rating="ratingQuestion28 = $event" />
                        <q-input v-model="question32Transport" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How confident are you in your safety?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion29" @update:rating="ratingQuestion29 = $event" />
                        <q-input v-model="question32Safety" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> How connected are you to places in your community?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion30" @update:rating="ratingQuestion30 = $event" />
                        <q-input v-model="question32CommunityCentres" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Are you close to (bus stops, chemist, shop)</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion31" @update:rating="ratingQuestion31 = $event" />
                        <q-input v-model="question32ProximityImportantPlaces" dense spellcheck="true" type="text"
                            maxlength="255" placeholder="Comments" />
                    </div>

                    <q-separator />

                    <div class="input-form-item">
                        <span class="input-question-text">Please provide a goal to help you achieve the changes you want to
                            make
                            if you have any: </span>
                    </div>
                    <div class="input-form-item">
                        <q-input class="full-width" outlined v-model="question33" type="textarea" spellcheck="true"
                            label="Enter your answer" />
                    </div>
                </div>
            </div>

            <!-- Step 5 -->
            <div v-show="myStep == 5">
                <div class="input-form-question-title hidden">
                    <h5>Rawa (Personal Resources)</h5>
                </div>

                <div class="input-form-question-container">
                    <div class="input-form-item">
                        <span class="input-question-text"> How would you rate your current education</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion34" @update:rating="ratingQuestion34 = $event" />
                        <q-input v-model="question39Education" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Your current employment options?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion35" @update:rating="ratingQuestion35 = $event" />
                        <q-input v-model="question39Employment" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Your money management (paying bills, savings, insurances)</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion36" @update:rating="ratingQuestion36 = $event" />
                        <q-input v-model="question39MoneyManagement" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Access to Housing NZ, legal support, EQC, WINZ?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion37" @update:rating="ratingQuestion37 = $event" />
                        <q-input v-model="question39AccessToFinancialSupport" dense spellcheck="true" type="text"
                            maxlength="255" placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Access to internet, telephone, etc?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion38" @update:rating="ratingQuestion38 = $event" />
                        <q-input v-model="question39Internet" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>

                    <q-separator />

                    <div class="input-form-item">
                        <span class="input-question-text">Please provide a goal to help you achieve the changes you want to
                            make
                            if you have any: </span>
                    </div>
                    <div class="input-form-item">
                        <q-input class="full-width" outlined v-model="question40" type="textarea" spellcheck="true"
                            label="Enter your answer" />
                    </div>
                </div>
            </div>

            <!-- Step 6 -->
            <div v-show="myStep == 6">
                <div class="input-form-question-title hidden">
                    <h5>Wairua (Spiritual)</h5>
                </div>

                <div class="input-form-question-container">
                    <div class="input-form-item">
                        <span class="input-question-text"> Value yourself as a person?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion41" @update:rating="ratingQuestion41 = $event" />
                        <q-input v-model="question44ValuingSelf" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text">
                            Connect to being Māori? (te reo, tikanga, kawa, kapa haka)
                        </span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion42" @update:rating="ratingQuestion42 = $event" />
                        <q-input v-model="question44ConnectionToTeAoMaori" dense spellcheck="true" type="text"
                            maxlength="255" placeholder="Comments" />
                    </div>
                    <q-separator />
                    <div class="input-form-item">
                        <span class="input-question-text"> Follow spiritual practices or your personal belief
                            systems?</span>
                        <star-rating :increment="0.5" text-class="vue-star-rating-text" class="input-question-stars"
                            :rounded-corners="true" :rating="ratingQuestion43" @update:rating="ratingQuestion43 = $event" />
                        <q-input v-model="question44FollowingSpiritual" dense spellcheck="true" type="text" maxlength="255"
                            placeholder="Comments" />
                    </div>

                    <q-separator />

                    <div class="input-form-item">
                        <span class="input-question-text">Please provide a goal to help you achieve the changes you want to
                            make
                            if you have any: </span>
                    </div>
                    <div class="input-form-item">
                        <q-input class="full-width" outlined v-model="question45" type="textarea" spellcheck="true"
                            label="Enter your answer" />
                    </div>
                </div>
            </div>
            <!-- Step 7 -->
            <div v-show="myStep == 7">
                <div class="form-completion-section">
                    <p class="text-h6">Thank you for filling out this Te Iti Kahurangi Form.</p>

                    <p class="text-h6">Please select where in your journey you are and submit the form:</p>

                    <div class="milestone-selection q-my-lg">
                        <q-select v-model="milestone" :options="['Initial Form', 'Check-in', 'Final Form']"
                            label="Milestone" outlined dense clearable class="milestone-select" />
                    </div>

                    <div class="milestone-selection">
                        <label class="form-label">Completed Date</label>
                        <q-input outlined v-model="submittedTime" mask="####-##-##" class="milestone-select"
                            :placeholder="dateFormat" clearable dense bg-color="white"
                            :rules="[(val) => (dayjs(val, dateFormat, true).isValid() || val == '') || 'Please enter a valid date']">
                            <template v-slot:append>
                                <q-icon name="event" class="cursor-pointer">
                                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                                        <q-date v-model="submittedTime" :mask="dateFormat" />
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                </div>
            </div>
        </div>

        <div class="button-container">
            <q-btn size="16px" flat no-caps color="primary" :disabled="filterDisable" v-if="myStep >= 1"
                @click="back">Previous Page</q-btn>
            <div class="button-spacer"></div>
            <q-btn size="16px" outline no-caps color="primary" :disabled="filterDisable" @click="saveProgress"
                v-show="myStep > 0 && myStep < 7">Save</q-btn>
            <q-btn size="16px" outlined no-caps color="primary" :disabled="filterDisable" @click="next"
                v-show="myStep > 0 && myStep < 7">Next Page</q-btn>
            <q-btn size="16px" :loading="submittingForm" outlined no-caps color="primary" v-if="myStep == 7"
                :disabled="!milestone" @click="uploadForm">Submit</q-btn>
        </div>

        <q-inner-loading :showing="submittingForm" label="Please wait, submitting form . . . " label-class="text-teal"
            label-style="font-size: 1.1em" />
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
import api from "../../../services/api/api";
import notify from "@/services/util/notify";
import dayjs from "@/services/util/dayjs";

import token from "@/services/util/roleHandler";
import FormHistoryResponse from "./FormHistoryResponseComponent.vue";

export default {
    name: "TeItiKahurangiFormEntry",
    components: {
        StarRating,
        FormHistoryResponse
    },
    props: {
        selectedClient: { type: Object, required: true },
        agreement: { type: Boolean, default: false },
        formId: { type: [String, Number], default: null }
    },
    emits: ["exit"],
    data: () => ({
        filterDisable: false,
        loading: false,
        ratingQuestion5: 0,
        ratingQuestion6: 0,
        ratingQuestion7: 0,
        ratingQuestion8: 0,
        question9Whanau: "",
        question9Friends: "",
        question9Community: "",
        question9Iwi: "",
        question10: "",
        ratingQuestion11: 0,
        ratingQuestion12: 0,
        ratingQuestion13: 0,
        ratingQuestion14: 0,
        ratingQuestion15: 0,
        ratingQuestion16: 0,
        question17GoalSetting: "",
        question17MoodManagement: "",
        question17Habits: "",
        question17ManagingUnwelcomeThoughts: "",
        question17AskingForHelp: "",
        question17ProblemSolving: "",
        question18: "",
        ratingQuestion19: 0,
        ratingQuestion20: 0,
        ratingQuestion21: 0,
        ratingQuestion22: 0,
        ratingQuestion23: 0,
        ratingQuestion24: 0,
        question25MovingWithoutPain: "",
        question25Exercise: "",
        question25HealthyEating: "",
        question25VisitingHealthProfessionals: "",
        question25ManagingAlcohol: "",
        question25UsingTraditionalMaoriMedicine: "",
        question26: "",
        ratingQuestion27: 0,
        ratingQuestion28: 0,
        ratingQuestion29: 0,
        ratingQuestion30: 0,
        ratingQuestion31: 0,
        question32Housing: "",
        question32Transport: "",
        question32Safety: "",
        question32CommunityCentres: "",
        question32ProximityImportantPlaces: "",
        question33: "",
        ratingQuestion34: 0,
        ratingQuestion35: 0,
        ratingQuestion36: 0,
        ratingQuestion37: 0,
        ratingQuestion38: 0,
        question39Education: "",
        question39Employment: "",
        question39MoneyManagement: "",
        question39AccessToFinancialSupport: "",
        question39Internet: "",
        question40: "",
        ratingQuestion41: 0,
        ratingQuestion42: 0,
        ratingQuestion43: 0,
        question44ValuingSelf: "",
        question44ConnectionToTeAoMaori: "",
        question44FollowingSpiritual: "",
        question45: "",
        milestone: null,
        completed: 0,
        temp_form_id: null,
        myStep: 1, // start at step 1 inside the form entry
        errors: [],
        selectedOptions: "",
        dayjs: dayjs,
        submittedTime: dayjs().format('YYYY-MM-DD'),
        dateFormat: "YYYY-MM-DD",

        submittingForm: false,

        userInfo: token.getTokenFields(),

        showHistoricResponses: false,
        maximizedToggle: true,

        sections: [
            { title: "Ūkaipō (Relationships)", step: 1 },
            { title: "Hinengaro (Mind)", step: 2 },
            { title: "Tinana (Physical)", step: 3 },
            { title: "Taiao (Environment)", step: 4 },
            { title: "Rawa (Personal Resources)", step: 5 },
            { title: "Wairua (Spiritual)", step: 6 },
            { title: "Completion", step: 7 }
        ]
    }),
    computed: {
        currentSectionTitle() {
            const section = this.sections.find((s) => s.step === this.myStep);
            return section ? section.title : "Select Section";
        }
    },
    methods: {
        async loadForm(formId) {
            try {
                this.loading = true;
                const res = await api.forms.getTeitiKahurangiFormById(formId);
                const r = res?.data || null;
                if (!r) return;

                // Ūkaipō (Relationships)
                this.ratingQuestion5 = r.u_whanau_rating;
                this.ratingQuestion6 = r.u_friends_rating;
                this.ratingQuestion7 = r.u_community_rating;
                this.ratingQuestion8 = r.u_iwi_rating;
                this.question9Whanau = r.u_whanau_goal || "";
                this.question9Friends = r.u_friends_goal || "";
                this.question9Community = r.u_community_goal || "";
                this.question9Iwi = r.u_iwi_goal || "";
                this.question10 = r.ukaipo_goals || "";

                // Hinengaro (Mind)
                this.ratingQuestion11 = r.h_setting_goals_rating;
                this.ratingQuestion12 = r.h_managing_mood_rating;
                this.ratingQuestion13 = r.h_managing_habits_rating;
                this.ratingQuestion14 = r.h_managing_thoughts_rating;
                this.ratingQuestion15 = r.h_asking_help_rating;
                this.ratingQuestion16 = r.h_problem_solving_rating;
                this.question17GoalSetting = r.h_goal_setting_goal || "";
                this.question17MoodManagement = r.h_managing_mood_goal || "";
                this.question17Habits = r.h_managing_habits_goal || "";
                this.question17ManagingUnwelcomeThoughts = r.h_unwelcome_thoughts_goal || "";
                this.question17AskingForHelp = r.h_asking_help_goal || "";
                this.question17ProblemSolving = r.h_problem_solving_goal || "";
                this.question18 = r.hinengaro_goals || "";

                // Tinana (Physical)
                this.ratingQuestion19 = r.ti_moving_without_pain_rating;
                this.ratingQuestion20 = r.ti_exercise_rating;
                this.ratingQuestion21 = r.ti_healthy_eating_rating;
                this.ratingQuestion22 = r.ti_vising_health_pro_rating;
                this.ratingQuestion23 = r.ti_managing_alcohol_rating;
                this.ratingQuestion24 = r.ti_using_maori_medicine_rating;
                this.question25MovingWithoutPain = r.ti_moving_without_pain_goal || "";
                this.question25Exercise = r.ti_exercise_goal || "";
                this.question25HealthyEating = r.ti_healthy_eating_goal || "";
                this.question25VisitingHealthProfessionals = r.ti_visting_health_pro_goal || "";
                this.question25ManagingAlcohol = r.ti_managing_alcohol_goal || "";
                this.question25UsingTraditionalMaoriMedicine = r.ti_using_maori_medicine_goal || "";
                this.question26 = r.tinana_goals || "";

                // Taiao (Environment)
                this.ratingQuestion27 = r.ta_housing_rating;
                this.ratingQuestion28 = r.ta_transport_access_rating;
                this.ratingQuestion29 = r.ta_safety_rating;
                this.ratingQuestion30 = r.ta_community_centres_rating;
                this.ratingQuestion31 = r.ta_proximity_key_places_ratings;
                this.question32Housing = r.ta_housing_goal || "";
                this.question32Transport = r.ta_transport_access_goal || "";
                this.question32Safety = r.ta_safety_goal || "";
                this.question32CommunityCentres = r.ta_community_centres_goal || "";
                this.question32ProximityImportantPlaces = r.ta_proximity_key_places_goal || "";
                this.question33 = r.taiao_goals || "";

                // Rawa (Personal Resources)
                this.ratingQuestion34 = r.r_education_rating;
                this.ratingQuestion35 = r.r_employment_rating;
                this.ratingQuestion36 = r.r_money_management_rating;
                this.ratingQuestion37 = r.r_housing_access_rating;
                this.ratingQuestion38 = r.r_internet_access_rating;
                this.question39Education = r.r_education_goal || "";
                this.question39Employment = r.r_employment_goal || "";
                this.question39MoneyManagement = r.r_money_management_goal || "";
                this.question39AccessToFinancialSupport = r.r_housing_access_goal || "";
                this.question39Internet = r.r_interent_goal || "";
                this.question40 = r.rawa_goals || "";

                // Wairua (Spiritual)
                this.ratingQuestion41 = r.w_valuing_self_rating;
                this.ratingQuestion42 = r.w_maori_connection_rating;
                this.ratingQuestion43 = r.w_following_practices_rating;
                this.question44ValuingSelf = r.w_valuing_self_goal || "";
                this.question44ConnectionToTeAoMaori = r.w_maori_connection_goal || "";
                this.question44FollowingSpiritual = r.w_following_practices_goal || "";
                this.question45 = r.wairua_goals || "";

                // Other
                this.milestone = r.milestone || null;
                this.completed = r.completed || 0;
                this.submittedTime = r.submitted_time || "";
            } catch (e) {
                // swallow minimal
            } finally {
                this.loading = false;
            }
        },

        // navigation
        back() {
            if (this.myStep > 1) {
                this.myStep--;
            } else {
                // go back to start (client + consent)
                this.$emit("exit");
            }
        },
        next() {
            this.myStep++;
        },
        setStep(step) {
            this.myStep = step;
        },

        saveProgress() {
            this.submittingForm = true;
            const formData = this.getFormSubmissionData();

            formData.completed = this.completed;

            api.forms.teitiKahurangiFormPost(formData)
                .then((res) => {
                    notify.primary("Successfully saved form progress!", "top");
                    this.temp_form_id = res?.data?.form_id || this.formId;
                })
                .catch((err) => {
                    notify.error(err.data.errors, "top");
                })
                .finally(() => {
                    this.submittingForm = false;
                });
        },

        uploadForm() {
            this.submittingForm = true;
            const formData = this.getFormSubmissionData();

            formData.completed = true;

            api.forms.teitiKahurangiFormPost(formData)
                .then(() => {
                    notify.primary("Successfully submitted form!", "top");
                    location.reload();
                })
                .catch((err) => {
                    notify.error(err.data.errors, "top");
                })
                .finally(() => {
                    this.submittingForm = false;
                });
        },

        getFormSubmissionData() {
            return {
                user_id: this.userInfo.email,
                email: this.selectedClient?.email,
                person_id: this.selectedClient?.person_id,
                client_id: this.selectedClient?.client_id,
                mobile: this.selectedClient?.mobile_phone,
                agreement: this.agreement,
                q5: this.ratingQuestion5,
                q6: this.ratingQuestion6,
                q7: this.ratingQuestion7,
                q8: this.ratingQuestion8,
                question9Whanau: this.question9Whanau.toString(),
                question9Friends: this.question9Friends.toString(),
                question9Community: this.question9Community.toString(),
                question9Iwi: this.question9Iwi.toString(),
                q10: this.question10.toString(),
                q11: this.ratingQuestion11,
                q12: this.ratingQuestion12,
                q13: this.ratingQuestion13,
                q14: this.ratingQuestion14,
                q15: this.ratingQuestion15,
                q16: this.ratingQuestion16,
                question17GoalSetting: this.question17GoalSetting.toString(),
                question17MoodManagement: this.question17MoodManagement.toString(),
                question17Habits: this.question17Habits.toString(),
                question17ManagingUnwelcomeThoughts: this.question17ManagingUnwelcomeThoughts.toString(),
                question17AskingForHelp: this.question17AskingForHelp.toString(),
                question17ProblemSolving: this.question17ProblemSolving.toString(),
                q18: this.question18.toString(),
                q19: this.ratingQuestion19,
                q20: this.ratingQuestion20,
                q21: this.ratingQuestion21,
                q22: this.ratingQuestion22,
                q23: this.ratingQuestion23,
                q24: this.ratingQuestion24,
                question25MovingWithoutPain: this.question25MovingWithoutPain.toString(),
                question25Exercise: this.question25Exercise.toString(),
                question25HealthyEating: this.question25HealthyEating.toString(),
                question25VisitingHealthProfessionals: this.question25VisitingHealthProfessionals.toString(),
                question25ManagingAlcohol: this.question25ManagingAlcohol.toString(),
                question25UsingTraditionalMaoriMedicine: this.question25UsingTraditionalMaoriMedicine.toString(),
                q26: this.question26.toString(),
                q27: this.ratingQuestion27,
                q28: this.ratingQuestion28,
                q29: this.ratingQuestion29,
                q30: this.ratingQuestion30,
                q31: this.ratingQuestion31,
                question32Housing: this.question32Housing.toString(),
                question32Transport: this.question32Transport.toString(),
                question32Safety: this.question32Safety.toString(),
                question32CommunityCentres: this.question32CommunityCentres.toString(),
                question32ProximityImportantPlaces: this.question32ProximityImportantPlaces.toString(),
                q33: this.question33.toString(),
                q34: this.ratingQuestion34,
                q35: this.ratingQuestion35,
                q36: this.ratingQuestion36,
                q37: this.ratingQuestion37,
                q38: this.ratingQuestion38,
                question39Education: this.question39Education.toString(),
                question39Employment: this.question39Employment.toString(),
                question39MoneyManagement: this.question39MoneyManagement.toString(),
                question39AccessToFinancialSupport: this.question39AccessToFinancialSupport.toString(),
                question39Internet: this.question39Internet.toString(),
                q40: this.question40.toString(),
                q41: this.ratingQuestion41,
                q42: this.ratingQuestion42,
                q43: this.ratingQuestion43,
                question44ValuingSelf: this.question44ValuingSelf.toString(),
                question44ConnectionToTeAoMaori: this.question44ConnectionToTeAoMaori.toString(),
                question44FollowingSpiritual: this.question44FollowingSpiritual.toString(),
                q45: this.question45.toString(),
                milestone: this.milestone,
                form_id: this.formId || this.temp_form_id || null,
                submitted_time: this.submittedTime || null
            };
        }
    },

    created() {
        if (this.formId) {
            this.loadForm(this.formId);
        }
    },
    watch: {
        formId(newVal) {
            if (newVal) {
                this.loadForm(newVal);
            }
        }
    }
};
</script>